import React from "react";
import { NavLink } from "react-router-dom";
import {
  Home,
  ClipboardList,
  Smartphone,
  Users,
  Wrench,
  User,
  FileText,
} from "lucide-react";
import "./Sidebar.css";
import servizyLogo from "../../assets/servizy-logo.png";

const Sidebar = ({ isOpen, closeSidebar }) => {
  return (
    <aside className={`sidebar ${isOpen ? "open" : "closed"}`}>
      <div className="sidebar-header">
        <div className="sidebar-brand">
          <img src={servizyLogo} alt="Servizy logo" className="sidebar-logo" />
        </div>
      </div>

      <nav className="sidebar-nav">
        <ul>
          <li>
            <NavLink to="/admin/dashboard" onClick={closeSidebar}>
              <span className="icon" aria-hidden="true">
                <Home size={18} />
              </span>
              {isOpen && <span>Dashboard</span>}
            </NavLink>
          </li>

          <li>
            <NavLink to="/admin/orders" onClick={closeSidebar}>
              <span className="icon" aria-hidden="true">
                <ClipboardList size={18} />
              </span>
              {isOpen && <span>Orders</span>}
            </NavLink>
          </li>

          

          <li>
            <NavLink to="/admin/addmodelbrands" onClick={closeSidebar}>
              <span className="icon" aria-hidden="true">
                <Smartphone size={18} />
              </span>
              {isOpen && <span>Add Model Brands</span>}
            </NavLink>
          </li>

          <li>
            <NavLink to="/admin/customers" onClick={closeSidebar}>
              <span className="icon" aria-hidden="true">
                <Users size={18} />
              </span>
              {isOpen && <span>Customers</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/services" onClick={closeSidebar}>
              <span className="icon" aria-hidden="true">
                <Wrench size={18} />
              </span>
              {isOpen && <span>Services</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/technicians" onClick={closeSidebar}>
              <span className="icon" aria-hidden="true">
                <User size={18} />
              </span>
              {isOpen && <span>Technicians</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/rfq" onClick={closeSidebar}>
              <span className="icon" aria-hidden="true">
                <FileText size={18} />
              </span>
              {isOpen && <span>RFQ</span>}
            </NavLink>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
